<div class="carousel-container">
    <div class="carousel-content">
        <!-- Texto do slide atual -->
        @if (hasSlides() && currentSlideData()) {
        <div class="carousel-text">
            <h2 class="carousel-title">{{ currentSlideData()!.title }}</h2>
            <p class="carousel-description">{{ currentSlideData()!.description }}</p>
        </div>
        }

        <!-- Imagens do carrossel -->
        <div class="carousel-wrapper">
            @for (slide of slides; track slide.imageSrc; let i = $index) {
            <div class="carousel-slide" [class.active]="currentSlide() === i">
                <img [src]="slide.imageSrc" [alt]="slide.imageAlt" />
            </div>
            }
        </div>

        <!-- Indicadores -->
    </div>
    @if (hasMultipleSlides()) {
    <div class="carousel-indicators" [attr.data-current]="currentSlide()" [attr.data-total]="slides.length">
        @for (slide of slides; track slide.imageSrc; let i = $index) {
        <button class="indicator" [class.active]="currentSlide() === i" (click)="goToSlide(i)"
            [attr.aria-label]="'Ir para slide ' + (i + 1)" [attr.data-index]="i">
        </button>
        }
    </div>
    }
</div>